<!-- <template>
  <div id="app">
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
      <router-view/>
  </div>
</template> -->


<template>
  <main id="app" class="">

    <nprogress-container></nprogress-container>  
        

        <div class="header">
          <!-- <router-link to="/"> -->
            <img class="logo" src="./assets/offshoresms-new-logo.png" alt="Offshore SMS">
          <!-- </router-link> -->
          <mobile-nav></mobile-nav>

        </div>

        <div class="header-spacer"></div>

        <!-- <div class="tab-details">
            <tab name="Step 1">
                This is step 1 of multi-step process.
            </tab>
            <tab name="Step 2">
               This is step 2 of multi-step process.
            </tab>
            <tab name="Step 3">
               This is step 3 of multi-step process.
            </tab>  
        </div>

        <br/>
        <div class="footer-nav">
          <button @click="changeTab(--currentActive,'slide-right')" v-if="currentActive > 1">Previous</button>
          <button @click="changeTab(++currentActive,'slide-left')" v-if="currentActive < totalTabs - 1">Next</button>
          <button v-if="currentActive == totalTabs -1">Done</button>
          <p>Num: {{currentActive}}</p>
        </div> -->

        <router-view></router-view>

        <div class="notification force-refresh" @click="refreshApp" v-if="updateExists">
          <!-- <button @click="showRefreshButton = true" class="delete is-small"></button> -->
          New content available!<br>Click to refresh.
        </div>


  </main>
</template>



<script>
  

import MobileNav from './components/MobileNav.vue';
import Vue from 'vue';
import NprogressContainer from 'vue-nprogress/src/NprogressContainer';
// import TextToSpeech from './components/TextToSpeech.vue';

Vue.config.devtools = false;




// Custom Directive to close modals on click outside
let handleOutsideClick;
Vue.directive('closable', {
  bind (el, binding, vnode) {
    // Here's the click/touchstart handler
    handleOutsideClick = (e) => {
      e.stopPropagation()
      // Get the handler method name and the exclude array from the object used in v-closable
      const { handler, exclude } = binding.value
      // This variable indicates if the clicked element is excluded
      let clickedOnExcludedEl = false
      exclude.forEach(refName => {
        // We only run this code if we haven't detected any excluded element yet
        if (!clickedOnExcludedEl) {
          // Get the element using the reference name
          const excludedEl = vnode.context.$refs[refName]
          // See if this excluded element is the same element the user just clicked on
          clickedOnExcludedEl = excludedEl.contains(e.target)
        }
      })
      // We check to see if the clicked element is not the modal element and not excluded
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        // If the clicked element is outside the modal and not the button, then call the outside-click handler from the same component this directive is used in
        vnode.context[handler]()
      }
    }
    // Register click/touchstart event listeners on the whole page
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },
  unbind () {
    // If the element that has v-closable is removed, then unbind click/touchstart listeners from the whole page
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
});





export default {
  components: {
    mobileNav : MobileNav,
    NprogressContainer,
    // TextToSpeech,
  },
  data() {
    return {
      transitionName: 'slide-right',
      tabs: [],
      currentActive: 0,
      totalTabs: 0,
      refreshing: false,
      registration: null,
      updateExists: false,
    }
  },

  created(){
    this.tabs = this.$children;
    document.addEventListener(
      'swUpdated', this.showRefreshUI, { once: true }
    );
    navigator.serviceWorker.addEventListener(
      'controllerchange', () => {
        if (this.refreshing) return;
        this.refreshing = true;
        window.location.reload();
      }
    );
  },

  mounted(){
      this.totalTabs = this.tabs.length;
  },

  methods:{
    changeTab(makeTabActive,slideMode) {
        this.tabs.forEach(tab => {
           tab.isActive = false;
        });
        
        this.tabs[makeTabActive].slideType = slideMode;
        this.tabs[makeTabActive].isActive = true;
        this.tabs[makeTabActive].slideType = slideMode;

    },

    showRefreshUI (e) {
      this.registration = e.detail;
      this.updateExists = true;
    },

    refreshApp () {
      this.updateExists = false;
      if (!this.registration || !this.registration.waiting) { return; }
      this.registration.waiting.postMessage('skipWaiting');
    },


  }

  // watch: {
  //   $route (to, from) {
  //     const toDepth = to.path.split('/').length
  //     const fromDepth = from.path.split('/').length
  //     console.log('Depth',toDepth,fromDepth);
  //     this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
  //   }
  // }

}


</script>



<style lang="scss">




#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
